export default __webpack_public_path__ + "static/media/user1.9725c855.jpg";